import commonFunction from '@/common/commonFunction';
export default {
	TaxReturnSubmissionFilterOptions: function() {
		return commonFunction.getDataFromEnum(
			'TaxReturnSubmissionFilterOptions'
		);
	},
	DeclareSubmissionTypeEnum: function() {
		return commonFunction.getDataFromEnum('DeclareSubmissionType');
	},
	StatusEnum: function() {
		return commonFunction.getDataFromEnum('TaxReturnStatusEnum2');
	},
	TypeTaxPeriod: function() {
		return commonFunction.getDataFromEnum('TypeTaxPeriod');
	},
	TaxReturnSubmissionData: function(state) {
		return state.TaxReturnSubmissionData;
	},
	Total: function(state) {
		return state.Total;
	},
	CachedQuickSearchText: function(state) {
		return state.CachedQuickSearchText;
	},
	CachedFilterOptions: function(state) {
		return state.CachedFilterOptions;
	},
	CachedFilterDisplay: function(state) {
		return state.CachedFilterDisplay;
	},
	AppendixTaxReturnSubmissionData: function(state) {
		return state.AppendixTaxReturnSubmissionData;
	},
	TaxReturnSubmissionHistoryData: function(state) {
		return state.TaxReturnSubmissionHistoryData;
	},
	TotalSubmissionHistoryData: function(state) {
		return state.TotalSubmissionHistoryData;
	},
	IsLoadingPaper: function(state) {
		return state.IsLoadingPaper;
	},
	TaxReturnHavePaidReportData: function(state) {
		return state.TaxReturnHavePaidReportData;
	}
};
